import { useTranslation } from "react-i18next";
import { convertTC2SC } from "./tc2sc-map";
import { TRANSLATIONS, type ExtraLocale } from "./bilingual-translations";

// Bilingual helper for hardcoded copy. Resolves to the active locale:
//  - en              → English source
//  - zh-Hant         → zh source (as passed in)
//  - zh-Hans / zh-CN → runtime TC→SC conversion of zh source
//  - de / fr / es / it / ar / ja → lookup in TRANSLATIONS map (falls back to English)
//
// Usage:
//   const b = useBilingual();
//   <h2>{b("Our Factory", "我們的工廠")}</h2>

const EXTRA_LOCALES: readonly ExtraLocale[] = ["de", "fr", "es", "it", "ar", "ja"];

const resolveExtraLocale = (lang: string): ExtraLocale | null => {
  // Normalise to the 2-letter prefix (e.g. "de-DE" → "de", "ja-JP" → "ja")
  const short = lang.slice(0, 2).toLowerCase();
  return (EXTRA_LOCALES as readonly string[]).includes(short)
    ? (short as ExtraLocale)
    : null;
};

export const useBilingual = () => {
  const { i18n } = useTranslation();
  return (en: string, zh: string) => {
    const lang = i18n.language || "";
    if (!lang) return en;
    if (lang === "zh-Hans" || lang === "zh-CN") return convertTC2SC(zh);
    if (lang.startsWith("zh")) return zh;
    const target = resolveExtraLocale(lang);
    if (!target) return en;
    const row = TRANSLATIONS[en];
    return row?.[target] || en;
  };
};
